import React from 'react';
import { cn } from '../../utils/cn';
import { spacing } from '../../utils/spacing';
import { Heading, Text } from './Typography';

interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
}

interface DialogContentProps {
  children: React.ReactNode;
  className?: string;
}

interface DialogHeaderProps {
  children: React.ReactNode;
  className?: string;
}

interface DialogTitleProps {
  children: React.ReactNode;
  className?: string;
}

interface DialogDescriptionProps {
  children: React.ReactNode;
  className?: string;
}

export function Dialog({ open, onOpenChange, children }: DialogProps) {
  if (!open) return null;

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center"
      style={{ zIndex: 'var(--z-modal)' }}
    >
      <div 
        className="fixed inset-0"
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }}
        onClick={() => onOpenChange(false)}
      />
      <div className="relative" style={{ zIndex: 'var(--z-modal)' }}>
        {children}
      </div>
    </div>
  );
}

export function DialogContent({ children, className = '' }: DialogContentProps) {
  return (
    <div 
      className={cn('max-w-lg w-full mx-4', className)}
      style={{
        backgroundColor: 'rgb(var(--color-surface))',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'var(--shadow-lg)',
      }}
    >
      {children}
    </div>
  );
}

export function DialogHeader({ children, className = '' }: DialogHeaderProps) {
  return (
    <div 
      className={cn('px-6 py-4', className)}
      style={{
        borderBottom: '1px solid rgb(var(--color-border))',
      }}
    >
      {children}
    </div>
  );
}

export function DialogTitle({ children, className = '' }: DialogTitleProps) {
  return (
    <Heading level={3} className={className}>
      {children}
    </Heading>
  );
}

export function DialogDescription({ children, className = '' }: DialogDescriptionProps) {
  return (
    <Text size="sm" className={cn('mt-1 text-text-secondary', className)}>
      {children}
    </Text>
  );
}
